import { render } from "./SignedInUserWrapper.vue?vue&type=template&id=7998038d&ts=true"
import script from "./SignedInUserWrapper.vue?vue&type=script&lang=ts"
export * from "./SignedInUserWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__